import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { loadPaymentsSuccessAction } from '../+state';
import { PaymentDto } from '../dtos';

export class PaymentsValidator extends Validator<PaymentDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return loadPaymentsSuccessAction({ payments: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Payments', ErrorCode.NoPayments))
      .build();
  }
}
